import { Component, Input, ElementRef, QueryList, ViewChildren, ViewChild, HostListener } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AutoResizeDirective } from '../../comun/directives/auto-resize.directive';
import { FuncionesService } from '../../comun/services/funciones.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { WebsocketService } from '../../comun/services/websocket.service';

@Component({
  selector: 'app-mensajes-modal',
  templateUrl: './mensajes-modal.component.html',
  styleUrl: './mensajes-modal.component.css'
})
export class MensajesModalComponent {
  @Input() userid: number = 0;
  @ViewChildren('mensajeTextarea') textareas!: QueryList<ElementRef<HTMLTextAreaElement>>;
  @ViewChild('autoResize') autoResize!: AutoResizeDirective;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('fileInputMensajes') fileInput!: ElementRef<HTMLInputElement>;
  useridold: number = 0;
  misdatos: any = {};
  perfil: any = {};
  mensaje: string = '';
  perfilesMensajes: any[] = [];
  perfilMensajes: any = {};
  mensajes: any[] = [];
  loadMensajes: boolean = false;
  showModal: boolean = false;
  enviando: boolean = false;
  private lastScrollTop = 0;
  alreadyTriggered = false;
  nuevomensaje: any = {me_id: 0, me_us_id_from: 0, me_us_id_to: 0, me_fechahora: '', me_mensaje: '', me_leido: '', me_borrado: '', me_us_borrado: 0, data:'', imagenes: [], previewUrl: []};
  private resizeObserver!: ResizeObserver;
  dropdownOpen: boolean = false;
  arrastrandoArchivos = false;
  previewAdjuntoIndex: number | null = null;
  mascotaCabecera: any = null;
  fotosPrivadas: any[] = [];
  mostrarAdjuntarOpciones = false;
  mostrarAlbumPrivado = false;
  cargandoAlbumPrivado = false;
  errorAlbumPrivado = '';
  private albumPrivadoCargado = false;
  private mascotaConsultaVersion = 0;
  private fotosAlbumUrls: string[] = [];
  private dragCounter = 0;
  private shouldAutoScroll = true;
  private wsSubscription!: Subscription;

  constructor(private query: QueryService,
              public funciones: FuncionesService,
              private http: HttpClient,
              private sanitizer: DomSanitizer,
              private wsService: WebsocketService) {}

  ngOnInit() {
    // WebSocket Nos quedamos escuchando de forma persistente
    this.wsSubscription = this.wsService.escucharNotificaciones().subscribe({
      next: (data) => {
        this.leerMensaje(this.perfil, data);
      },
      error: (err) => console.error(err),
    });

    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        this.checkOnline(this.perfil);
      });
    });
  }  

  ngAfterViewInit() {
    const modal = document.getElementById('mensajesModal');
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        // Obtener parámetros de la ventana
        //const params = (window as any).angularMensajesModalParams;
        //this.userid = params?.userid || 0;
        this.getMisDatos();
      });
      const handler = () => {
        if (this.useridold != 0)
          this.userid = this.useridold;
        this.mensajes.length = 0;
        this.showModal = false;
      };
      modal?.addEventListener('hidden.bs.modal', handler, { once: false });
    }

    // Auto scroll
    const el = this.scrollContainer.nativeElement;
    this.resizeObserver = new ResizeObserver(() => {
      if (this.shouldAutoScroll) {
        el.scrollTop = el.scrollHeight;
      }
    });
    this.resizeObserver.observe(el);
  }

  leerAllMensajes() {
    this.query.query('mensajes', 'LEERMENSAJESTODOS', { me_us_id_from: this.perfil.ID, me_us_id_to: this.misdatos.ID }).subscribe((resultado:any) => {
      this.sendNotificacion(0, 'CHAT_LEERMENSAJES', 'Leer mensajes');
    });
  }

  getMisDatos() {
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      this.getPerfil();
    });
  }

  getPerfil() {
    if (this.userid == this.misdatos.ID) {
      this.perfil = this.misdatos;
      this.checkOnline(this.perfil);
      this.mostrarPerfilesMensajes();
    } else {
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        this.checkOnline(this.perfil);
        this.mostrarPerfilesMensajes();
      });
    }
  }

  mostrarPerfilesMensajes() {
    this.showModal = true;
    if (this.misdatos.ID != this.userid) {
      this.verMensajes(this.perfil);
    } else {
      this.getPerfilesMensajes();
    }
  }

  verMensajes(perfil: any) {    
    this.checkOnline(perfil);
    this.loadMensajes = false;
    this.cargarMascotaCabecera(perfil);
    // Para que lea todos los mensajes leidos y no leidos
    perfil.leidos = 'T';
    perfil.me_id = 0;
    this.query.query('mensajes', 'GETMENSAJES', perfil).subscribe((resultado:any) => {
      this.mensajes = resultado.registros;
      this.perfilMensajes = perfil;
      this.loadMensajes = true;
      setTimeout(() => {
        this.autoResize.ajustarAltura();
        this.focoTextarea();
        this.scrollToBottom();
      }, 100);

      this.leerAllMensajes();

      /*// Obtener y borrar los mensajes en firebase
      this.chatService.obtenerMensajes(this.userid.toString(), this.misdatos.ID.toString(), '')
        .subscribe(mensajes => {
          // Solo cuando el modal esté abierto, visible
          if (this.showModal && this.misdatos.ID != this.userid) {
            // Esto se ejecuta cuando recibes un mensaje de otro usuario
            mensajes.forEach(m => {            
              // Añadir mensaje al array
              // Para que lea los mensajes por id y no leidos
              perfil.leidos = '';
              perfil.me_id = m.me_id;
              this.query.query('mensajes', 'LEERMENSAJE', perfil).subscribe((resultado:any) => {
                this.query.query('mensajes', 'GETMENSAJES', perfil).subscribe((resultado:any) => {
                  const nuevo = resultado.registros[0];
                  if (!this.mensajes.some(m => m.me_id === nuevo.me_id)) {
                    this.mensajes.push({ ...nuevo });
                  }
                  setTimeout(() => {
                    this.scrollToBottom();
                  },500);
                  // Luego lo borras de firebase
                  if (m.id) {
                    this.chatService.borrarMensajeDespuesDeAvisar(m.id, 10);
                  }
                });
              });
            });
          }
        });*/
    });
  }

  leerMensaje(_perfil: any, aviso: any): void {
    // Los avisos WebSocket pueden llegar mientras el usuario consulta la lista
    // de chats. Solo actualizamos el hilo abierto del usuario conectado.
    if (!this.showModal || !this.loadMensajes || !this.misdatos?.ID) return;

    const miId = Number(this.misdatos.ID);
    const interlocutorId = Number(this.perfil?.ID);
    const remitente = Number(aviso?.user_from);
    const destinatario = Number(aviso?.user_to);
    const idMensaje = Number(aviso?.me_id);

    if (!interlocutorId || interlocutorId === miId || !idMensaje) return;
    if (!((remitente === interlocutorId && destinatario === miId) ||
          (remitente === miId && destinatario === interlocutorId))) return;

    // Al recibir un mensaje para esta conversación, consultar de nuevo la
    // presencia del interlocutor. La cabecera usa el mismo objeto this.perfil.
    // Hacerlo antes de comprobar duplicados: también refresca el estado si
    // el aviso del WebSocket corresponde a un mensaje ya cargado.
    this.checkOnline(this.perfil);

    // El servidor también notifica al emisor, pero ese mensaje ya se añade
    // localmente al completar SEND. Evitamos una doble inserción.
    if (this.mensajes.some(m => Number(m.me_id) === idMensaje)) return;

    const parametros = { ...this.perfil, leidos: '', me_id: idMensaje };
    this.query.query('mensajes', 'LEERMENSAJE', parametros).subscribe({
      next: () => {
        this.query.query('mensajes', 'GETMENSAJES', parametros).subscribe({
          next: (resultado: any) => {
            // Evitar mezclar conversaciones si el usuario cambia de chat
            // durante la consulta asíncrona.
            if (!this.showModal || Number(this.perfil?.ID) !== interlocutorId) return;
            const nuevo = (resultado?.registros || []).find((m: any) => Number(m.me_id) === idMensaje);
            if (!nuevo || this.mensajes.some(m => Number(m.me_id) === idMensaje)) return;
            this.mensajes = [...this.mensajes, nuevo];
            // Un mensaje entrante debe mostrarse aunque el usuario haya
            // desplazado el chat hacia arriba (shouldAutoScroll === false).
            // Esperar a que Angular renderice el nuevo mensaje.
            setTimeout(() => {
              if (!this.showModal || Number(this.perfil?.ID) !== interlocutorId) return;
              const contenedor = this.scrollContainer?.nativeElement;
              if (!contenedor) return;
              this.shouldAutoScroll = true;
              contenedor.scrollTop = contenedor.scrollHeight;
              requestAnimationFrame(() => {
                if (this.showModal && Number(this.perfil?.ID) === interlocutorId) {
                  contenedor.scrollTop = contenedor.scrollHeight;
                }
              });
            }, 50);
          },
          error: err => console.error('No se pudo recuperar el mensaje recibido:', err)
        });
      },
      error: err => console.error('No se pudo marcar el mensaje como leído:', err)
    });
  }

  enviarMensaje(): void {
    const textoLimpio = (this.mensaje || '').trim();
    const tieneImagenes = this.nuevomensaje.imagenes.length > 0;

    if (!textoLimpio && !tieneImagenes) {
      return;
    }
    this.enviando = true;
    this.dropdownOpen = false;

    // Comprobamos ANTES si el usuario estaba abajo
    const shouldScroll = this.isNearBottom();

    // Preparamos el mensaje (copia para evitar referencias raras)
    const nuevoMensaje = {
      me_id: 0,
      me_us_id_from: this.misdatos.ID,
      me_us_id_to: this.userid,
      me_mensaje: textoLimpio || 'foto'
    };

    this.mensaje = '';

    this.query.query('mensajes', 'SEND', nuevoMensaje)
      .subscribe((resultado: any) => {
        nuevoMensaje.me_id = resultado.id;

        // Fotos
        const llamadas: any[] = [];
        for (const imagen of this.nuevomensaje.imagenes) {
          if (imagen.url == '') {
            const formData = new FormData();
            formData.append('data', imagen.data);
            formData.append('principal', '');
            formData.append('tipo', 'CH'); // Chat
            formData.append('tipo_id', resultado.id);
            const token = localStorage.getItem('token');
            const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
            llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
          }
        }
        if (llamadas.length > 0) {
          // Convertir array → objeto para evitar deprecación
          const llamadasObj = llamadas.reduce((acc, obs, i) => {
            acc[i] = obs;
            return acc;
          }, {} as { [key: string]: any });

          forkJoin(llamadasObj).subscribe(resultados => {
            this.getMensaje(nuevoMensaje);
          });
        } else {
          this.getMensaje(nuevoMensaje);
        }
      });
  }

  getMensaje(nuevoMensaje: any) {
    this.query.query('mensajes', 'GETMENSAJES', { me_id: nuevoMensaje.me_id }).subscribe((resultado:any) => {
      this.limpiarAdjuntos();
      // Añadimos el mensaje AL FINAL del array
      this.mensajes.push({
        ...resultado.registros[0]
      });
      this.enviando = false;

      // Tras enviar, desplazarse al nuevo mensaje incluso si el usuario
      // había subido manualmente por el historial.
      this.shouldAutoScroll = true;
      setTimeout(() => {
        this.autoResize?.ajustarAltura();
        this.scrollToBottom(false, true);
        requestAnimationFrame(() => this.scrollToBottom(false, true));
        this.focoTextarea();
      }, 100);

      // Avisamos a Firebase para notificar al otro usuario
      //this.chatService.enviarMensaje(nuevoMensaje.me_id.toString(), this.misdatos.ID.toString(), this.userid.toString(), '');
      this.sendNotificacion(nuevoMensaje.me_id, 'CHAT_NUEVOMENSAJE', 'Nuevo mensaje');
    });
  }

  getPerfilesMensajes() {
    // Perfil del propio usuario
    this.loadMensajes = false;
    if (this.userid == this.misdatos.ID) {
      this.query.query('mensajes', 'GETPERFILES', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfilesMensajes = resultado.registros;
        this.perfilesMensajes.forEach(perfil => {
           this.checkOnline(perfil);
        });
        this.loadMensajes = true;
      });
    }
  }

  seleccionarPerfil(perfil: any) {
    this.perfil = perfil;
    this.useridold = this.userid;
    this.userid = perfil.ID;
  }

  atras() {
    this.mensajes.length = 0;
    this.userid = this.useridold;
    this.useridold = 0;
    this.perfil = this.misdatos;
    this.mostrarPerfilesMensajes();
  }

  focoTextarea() {
    const textarea = this.textareas.last;
    textarea?.nativeElement.focus();
  }

  onEnter(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;

    keyboardEvent.preventDefault();

    this.mensaje = this.mensaje
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .trim();

    if (!keyboardEvent.shiftKey) {
      this.enviarMensaje();
    }
  }

  isNearBottom(): boolean {
    const el = this.scrollContainer.nativeElement;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 40;
  }

  scrollToBottom(smooth = true, forzar = false): boolean {
    if ((!this.shouldAutoScroll && !forzar) || !this.scrollContainer) {
      return false;
    }

    const el = this.scrollContainer.nativeElement;

    if (smooth) {
      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'smooth'
      });
    } else {
      el.scrollTop = el.scrollHeight;
    }

    return true;
  }



  get puedeEnviar(): boolean {
    return !!this.mensaje?.trim() || this.nuevomensaje.imagenes.length > 0;
  }

  eliminarAdjunto(index: number): void {
    if (index < 0 || index >= this.nuevomensaje.imagenes.length) return;
    this.nuevomensaje.imagenes.splice(index, 1);
    this.cerrarPreview();
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  limpiarAdjuntos(): void {
    this.nuevomensaje.imagenes = [];
    this.cerrarPreview();
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  ngOnDestroy(): void {
    this.fotosAlbumUrls.forEach(url => URL.revokeObjectURL(url));
    this.mensajes = [];
    this.cerrarPreview();
    this.resizeObserver?.disconnect();
    // Buenas prácticas: nos desuscribimos al destruir el componente para evitar fugas de memoria
    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
    }
  }  

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const current = element.scrollTop;

    const scrollingUp = current < this.lastScrollTop;
    const atTop = current === 0;

    // Detectar si está cerca del bottom
    this.shouldAutoScroll = this.isNearBottom();

    if (scrollingUp && atTop && !this.alreadyTriggered) {
      this.alreadyTriggered = true;
      this.onReachTop();
    }

    // Reset cuando baja un poco
    if (current > 0) {
      this.alreadyTriggered = false;
    }

    this.lastScrollTop = current;
  }

  // Tope superior de scroll
  onReachTop() {
    // cargar los anteriores 5 mensajes
    this.cargarMensajesAnteriores();
  }

  cargarMensajesAnteriores() {
    // Para que lea todos los mensajes leidos y no leidos
    if (this.mensajes.length == 0)
      return;
    this.perfil.leidos = 'T';
    this.perfil.me_id = 0;
    this.perfil.me_id_anterior = this.mensajes[0].me_id;

    // bloquear autoscroll
    this.shouldAutoScroll = false;

    this.query.query('mensajes', 'GETMENSAJES', this.perfil).subscribe((resultado:any) => {
      const container = this.scrollContainer.nativeElement;

      // Guardamos altura y posición actual
      const oldScrollHeight = container.scrollHeight;
      const oldScrollTop = container.scrollTop;

      // Prependemos mensajes
      this.mensajes = [...resultado.registros, ...this.mensajes];

      setTimeout(() => {
        const newScrollHeight = container.scrollHeight;

        container.scrollTop =
          newScrollHeight - oldScrollHeight + oldScrollTop;

        // reactivar solo si corresponde
        this.shouldAutoScroll = this.isNearBottom();
      },100);
    });
  }

  copiarMensaje(mensaje: any) {
    navigator.clipboard.writeText(mensaje.me_mensaje).then(() => {
    }).catch(err => {
    });
  }

  async borrarMensaje(mensaje: any): Promise<void> {
    const propio = Number(mensaje.me_us_id_from) === Number(this.misdatos?.ID);
    const opciones: any = {
      title: 'Eliminar mensaje',
      text: 'Elige cómo quieres eliminar este mensaje.',
      icon: 'question',
      showCancelButton: true,
      showDenyButton: propio,
      confirmButtonText: 'Solo para mí',
      denyButtonText: 'Para todos',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    };
    const decision = await Swal.fire(opciones);
    if (!decision.isConfirmed && !decision.isDenied) return;
    const paraTodos = decision.isDenied;
    if (paraTodos) {
      const confirmacion = await Swal.fire({
        title: '¿Eliminar para ambos?',
        text: 'El mensaje dejará de verse para ambos usuarios. Sus fotos adjuntas se eliminarán definitivamente del chat, pero las originales de tu álbum privado se conservarán.',
        icon: 'warning', showCancelButton: true,
        confirmButtonText: 'Eliminar para todos', cancelButtonText: 'Cancelar'
      });
      if (!confirmacion.isConfirmed) return;
    }
    this.query.query('mensajes', 'BORRARMENSAJE', {
      me_id: mensaje.me_id, para_todos: paraTodos
    }).subscribe({
      next: (respuesta: any) => {
        if (respuesta?.resultado !== 'OK') {
          Swal.fire('No se pudo eliminar', respuesta?.mensaje || 'Inténtalo de nuevo.', 'error');
          return;
        }
        if (paraTodos) {
          mensaje.me_us_borrado = Number(this.misdatos?.ID);
          mensaje.me_borrado = respuesta.me_borrado;
          mensaje.fotos = [];
        } else {
          const index = this.mensajes.findIndex((m: any) => Number(m.me_id) === Number(mensaje.me_id));
          if (index >= 0) this.mensajes.splice(index, 1);
        }
      },
      error: (err: any) => Swal.fire('No se pudo eliminar', err?.error?.mensaje || 'Inténtalo de nuevo.', 'error')
    });
  }

  // La mascota mostrada pertenece al destinatario, no al usuario conectado.
  cargarMascotaCabecera(perfil: any): void {
    this.mascotaCabecera = null;
    const version = ++this.mascotaConsultaVersion;
    const id = Number(perfil?.ID || 0);
    if (!id || id === Number(this.misdatos?.ID)) return;
    this.query.query('mascotas', 'GET', {ID: id, ma_id: 0}).subscribe({
      next: (res: any) => {
        // Evita aplicar una respuesta antigua si se cambia de conversación.
        if (version !== this.mascotaConsultaVersion) return;
        const rows: any[] = Array.isArray(res?.registros) ? res.registros : (Array.isArray(res) ? res : []);
        this.mascotaCabecera = rows.find((m: any) => m.foto?.ft_id && m.ma_novisible !== 'X') || null;
      },
      error: () => { this.mascotaCabecera = null; }
    });
  }

  alternarAdjuntos(event?: Event): void {
    event?.stopPropagation();
    this.mostrarAdjuntarOpciones = !this.mostrarAdjuntarOpciones;
    this.dropdownOpen = false;
  }

  abrirAlbumPrivado(): void {
    this.mostrarAdjuntarOpciones = false;
    this.mostrarAlbumPrivado = true;
    this.errorAlbumPrivado = '';
    if (!this.albumPrivadoCargado) this.cargarAlbumPrivado();
  }

  private headersPrivados(): HttpHeaders {
    const token = localStorage.getItem('token');
    return token ? new HttpHeaders({Authorization: `Bearer ${token}`}) : new HttpHeaders();
  }

  private urlFotoPrivada(id: number, mini: boolean): string {
    return GlobalConstants.urlServer + 'backend/api/privadas.php?foto=' + id + '&mini=' + (mini ? '1' : '0');
  }

  cargarAlbumPrivado(): void {
    this.cargandoAlbumPrivado = true;
    this.errorAlbumPrivado = '';
    this.query.query('privadas', 'GET', null).subscribe({
      next: (res: any) => {
        this.cargandoAlbumPrivado = false;
        if (res?.resultado !== 'OK') {
          this.errorAlbumPrivado = res?.mensaje || 'No se pudieron consultar tus fotografías privadas.';
          return;
        }
        this.albumPrivadoCargado = true;
        this.fotosPrivadas = Array.isArray(res.registros) ? res.registros : [];
        this.fotosPrivadas.forEach((f: any) => {
          this.http.get(this.urlFotoPrivada(f.ft_id, true), {headers: this.headersPrivados(), responseType: 'blob'})
            .subscribe({next: blob => {
              const url = URL.createObjectURL(blob);
              this.fotosAlbumUrls.push(url);
              f.miniUrl = url;
            }, error: () => { f.miniUrl = ''; }});
        });
      },
      error: (err: any) => {
        this.cargandoAlbumPrivado = false;
        this.errorAlbumPrivado = err?.error?.mensaje || 'No se pudieron consultar tus fotografías privadas.';
      }
    });
  }

  adjuntarPrivada(f: any): void {
    if (f.adjuntando) return;
    f.adjuntando = true;
    this.errorAlbumPrivado = '';
    // Se descarga con la sesión propia y se adjunta una COPIA al chat;
    // la foto original continúa siendo privada y no se modifica.
    this.http.get(this.urlFotoPrivada(f.ft_id, false), {headers: this.headersPrivados(), responseType: 'blob'})
      .subscribe({
        next: blob => {
          const reader = new FileReader();
          reader.onload = () => {
            f.adjuntando = false;
            if (typeof reader.result !== 'string') return;
            this.nuevomensaje.imagenes.push({
              data: reader.result, preview: reader.result, url: '',
              nombre: f.ft_titulo || 'Foto privada', size: blob.size
            });
            this.mostrarAlbumPrivado = false;
          };
          reader.onerror = () => {
            f.adjuntando = false;
            this.errorAlbumPrivado = 'No se pudo preparar la fotografía para adjuntarla.';
          };
          reader.readAsDataURL(blob);
        },
        error: (err: any) => {
          f.adjuntando = false;
          this.errorAlbumPrivado = err?.error?.mensaje || 'No se pudo adjuntar esa fotografía.';
        }
      });
  }

  onClickImagen() {
    // Simula el click en el input file
    this.fileInput.nativeElement.click();
  }

  abrirPreview(index: number): void { this.previewAdjuntoIndex = index; }
  cerrarPreview(): void { this.previewAdjuntoIndex = null; }

  // Bootstrap no debe cerrar el chat cuando Escape cierra una foto ampliada.
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeFoto(event: KeyboardEvent): void {
    if (this.previewAdjuntoIndex !== null) {
      event.preventDefault();
      event.stopPropagation();
      this.cerrarPreview();
    }
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter++;
    this.arrastrandoArchivos = true;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter = Math.max(0, this.dragCounter - 1);
    if (this.dragCounter === 0) this.arrastrandoArchivos = false;
  }

  onDropImagenes(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter = 0;
    this.arrastrandoArchivos = false;
    if (event.dataTransfer?.files?.length) this.adjuntarArchivos(Array.from(event.dataTransfer.files));
  }

  private adjuntarArchivos(archivos: File[]): void {
    for (const file of archivos) {
      if (!file.type.startsWith('image/')) continue;
      const lector = new FileReader();
      lector.onload = () => {
        if (typeof lector.result !== 'string') return;
        this.nuevomensaje.imagenes.push({data: lector.result, url: '', nombre: file.name, size: file.size, preview: lector.result});
      };
      lector.readAsDataURL(file);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) this.adjuntarArchivos(Array.from(input.files));
    input.value = '';
  }

  // Lista de emojis
  emojis: string[] = ['😀','😂','😍','🥰','😊','😎','😢','🥺','😮','❤️','💚','🐾','🐶','🐱','🐕','🐈','👍','👏','🙏','🎉','✨','🌞','🌈','💐'];

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation(); // evita que document:click cierre inmediatamente
    }
    this.dropdownOpen = !this.dropdownOpen;
  }

  seleccionarEmoji(emoji: string) {
    this.mensaje += emoji;
    this.dropdownOpen = false;
  }

  // Cerrar el desplegable al hacer click fuera
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;

    // Si el click está dentro del contenedor del picker, no cerramos
    if (!target.closest('.emoji-picker-container')) {
      this.dropdownOpen = false;
    }
  }

  formatEmojiImages(html: string): SafeHtml {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const images = doc.querySelectorAll('img.emoji');

    images.forEach((img) => {
      const image = img as HTMLImageElement; // <-- tipo correcto
      const alt = image.getAttribute('alt');

      if (alt && this.emojis.includes(alt)) {
        image.classList.add('big-emoji');
      }
    });

    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }

  checkOnline(perfil: any): void {
    const id = Number(perfil?.ID);
    if (!id) return;
    this.http.get<{ online: boolean }>(
      GlobalConstants.urlServer + `wp-json/custom/v1/user-online/${id}`
    ).subscribe({
      next: (res) => {
        // Evitar aplicar una respuesta antigua a otro interlocutor.
        if (Number(perfil?.ID) !== id) return;
        perfil.online = !!res?.online;
        // Si se consultó un perfil de la lista, mantener la lista ordenada.
        if (this.perfilesMensajes.some(p => Number(p.ID) === id)) {
          this.ordenarPerfiles();
        }
      },
      error: (err) => console.error('[iGuau / presencia del chat]', err)
    });
  }

  ordenarPerfiles() {
    this.perfilesMensajes.sort((a: any, b: any) => {

      // 1️⃣ numero (mayor primero)
      if ((b.numero || 0) !== (a.numero || 0)) {
        return (b.numero || 0) - (a.numero || 0);
      }

      /*// 2️⃣ online
      if (a.online && !b.online) return -1;
      if (!a.online && b.online) return 1;*/

      // 3️⃣ fecha (más reciente primero)
      return (b.me_fechahora || '').localeCompare(a.me_fechahora || '');
    });
  }

  sendNotificacion(me_id: number = 0, tipo: string = '', mensaje: string = '') {
    // Enviar notificación al websocket
    const notificacion = {      
      tipo: tipo,
      me_id: me_id,
      user_from: this.misdatos.ID,
      user_to: this.perfil.ID,
      mensaje: mensaje,
    };
    // Esto viaja al servidor Node.js
    this.wsService.enviarNotificacion(notificacion);
  }

}
